import InternetExplorer from './InternetExplorer';
import Minesweeper from './Minesweeper';
import ErrorBox from './ErrorBox';
import MyComputer from './MyComputer';
import Notepad from './Notepad';
import Winamp from './Winamp';
import Paint from './Paint';
import PdfViewer from './PdfViewer';
import StickyNote from 'assets/stick_note.png';
import iePaper from 'assets/windowsIcons/ie-paper.png';
import ie from 'assets/windowsIcons/ie.png';
import hireMe from 'assets/windowsIcons/hire_me_icon.png';
import mine from 'assets/minesweeper/mine-icon.png';
import pdf from 'assets/windowsIcons/pdf.png';
import error from 'assets/windowsIcons/897(16x16).png';
import computer from 'assets/windowsIcons/676(16x16).png';
import computerLarge from 'assets/windowsIcons/676(32x32).png';
import notepad from 'assets/windowsIcons/327(16x16).png';
import notepadLarge from 'assets/windowsIcons/327(32x32).png';
import winamp from 'assets/windowsIcons/winamp.png';
import paintLarge from 'assets/windowsIcons/680(32x32).png';
import paint from 'assets/windowsIcons/680(16x16).png';

import VideoViewer from './VideoViewer';


import RoomScan from 'assets/room_scan.png';
import scanner from 'assets/scanner.png';
import food from 'assets/food.png';

import goldApp from 'assets/gold_app.png';



const gen = () => {
  let id = -1;
  return () => {
    id += 1;
    return id;
  };
};
const genId = gen();
const genIndex = gen();
export const defaultAppState = [
];
//https://youtu.be/sAK8rpZkuB0
//https://youtu.be/65WqnDa_ziw
//https://youtu.be/cHjMnBXNdss
const myApps =[{
    icon: scanner,
    title: 'Room Scanner',
    component: VideoViewer,
    url: "https://www.youtube.com/embed/9upz29Gxxsw"}
    ,{
    icon: RoomScan,
    title: 'Real Estate App',
    component: VideoViewer,
    url: "https://www.youtube.com/embed/sAK8rpZkuB0"}
    ,{
    icon: food,
    title: 'Food Delivery',
    component: VideoViewer,
    url: "https://www.youtube.com/embed/65WqnDa_ziw"}
    ,{
    icon: goldApp,
    title: 'Commodity Trading',
    component: VideoViewer,
    url: "https://www.youtube.com/embed/cHjMnBXNdss"}
  ]
goldApp
export const defaultIconState = [
  {
    id: 0,
    icon: ie,
    title: 'Internet Explorer',
    component: InternetExplorer,
    isFocus: false,
  },
   {
    id: 1,
    icon: hireMe,
    title: 'Hire Me',
    isFocus: false,
    onClick: "https://www.upwork.com/freelancers/~0187a8814e2977e928?viewMode=1"
  },
  {
    id: 2,
    icon: pdf,
    title: 'MyResume.pdf',
    component: PdfViewer,
    isFocus: false,
  },
  {
    id: 3,
    icon: StickyNote,
    title: '',
    component: "note",
    isFocus: false,
  }
];

export const appSettings = {
  'Internet Explorer': {
    header: {
      icon: iePaper,
      title: 'The InternetExplorer',
    },
    component: InternetExplorer,
    defaultSize: {
      width: 700,
      height: 500,
    },
    defaultOffset: {
      x: 140,
      y: 30,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  Minesweeper: {
    header: {
      icon: mine,
      title: 'Minesweeper',
    },
    component: Minesweeper,
    defaultSize: {
      width: 0,
      height: 0,
    },
    defaultOffset: {
      x: 190,
      y: 180,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: true,
  },
  Error: {
    header: {
      icon: error,
      title: 'C:\\',
      buttons: ['close'],
      noFooterWindow: true,
    },
    component: ErrorBox,
    defaultSize: {
      width: 380,
      height: 0,
    },
    defaultOffset: {
      x: window.innerWidth / 2 - 190,
      y: window.innerHeight / 2 - 60,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: true,
  },
  'Abstract Computer': {
    header: {
      icon: computer,
      title: 'Abstract Computer',
    },
    component: MyComputer,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 260,
      y: 50,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
    Notepad: {
      header: {
        icon: notepad,
        title: 'Untitled - Notepad',
      },
      component: Notepad,
      defaultSize: {
        width: 660,
        height: 500,
      },
      defaultOffset: {
        x: 270,
        y: 60,
      },
      resizable: true,
      minimized: false,
      maximized: window.innerWidth < 800,
      multiInstance: true,
    },
  PdfViewer: {
    header: {
      icon: pdf,
      title: 'MyResume.pdf',
    },
    component: PdfViewer,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 280,
      y: 70,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  VideoViewer: {
    header: {
      icon: pdf,
      title: 'Video Viewer',
    },
    component: VideoViewer,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 280,
      y: 70,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
    title: 'MyResume.pdf',
    component: VideoViewer,
    url: "https://www.youtube.com/embed/SoIIz3An2k4",
  },
  Winamp: {
    header: {
      icon: winamp,
      title: 'Winamp',
      invisible: true,
    },
    component: Winamp,
    defaultSize: {
      width: 0,
      height: 0,
    },
    defaultOffset: {
      x: 0,
      y: 0,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: false,
  },
  Paint: {
    header: {
      icon: paint,
      title: 'Untitled - Paint',
    },
    component: Paint,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 280,
      y: 70,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
};

let nextId = defaultIconState.length > 0 
  ? Math.max(...defaultIconState.map(icon => icon.id)) + 1 
  : 0;

  myApps.forEach((app, index) => {

  defaultIconState.push({
    id: nextId++,
    icon: app.icon,
    title: app.title, 
    component: app.component,
    url: app.url,
    isFocus: false
  });

  appSettings[app.title] = {
    header: {
      icon: app.icon,
      title: app.title,
    },
    component: app.component,
    url: app.url, 
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 280 + (index * 20), 
      y: 70 + (index * 20),
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  };
});

export { InternetExplorer, Minesweeper, ErrorBox, MyComputer, Notepad, Winamp };
